import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser,
  getFetcherHeader
} from '../../modules/ajio-fetch/utils.js';
import fetcher from '../../modules/ajio-fetch';
import { EDDAction } from '../constants/index.js';
import { getHostName } from '../../utils/sisUtils';
// import "whatwg-fetch";
import { readCookie } from '../../components/common/Cookie';
import { addProductToWishlist } from '../../wishlist/actions/wishlist.js';
import { deleteBulkItemsFromCart } from '../../cart/actions/cart.js';
import { getAjioWalletEarnData } from '../../myaccount/actions/ajiowallet.js';
import { hideModal } from '../../actions/modal.js';
import { ModalTypes } from '../../constants/index.js';
import { getPincodeFromCookie, getServiceOrNonServicabilityItems } from '../utils/utils.js';
import { setErrorObject } from '../../actions/shared/HTTPError';
import properties from '../../modules/ajio-util/properties';
import isNode from '../../modules/ajio-util/isNode.js';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';
import { signInCheck } from '../../components/common/CheckUserStatus';
import luxeScreen from '../../refresh/constants/luxeScreenType';
import {
  getEmiDiscountEnableForPDP,
  getMultiSellerSlaFlag,
  getRushDeliveryFlag
} from '../../refresh/selectors/featureFlagsSelector';
import { hasServiceableSlaOption } from '../../refresh/molecules/DeliverySLA/mapDeliverySLA';

const login_url = properties.getProperty('loginPageURL');
const api_url = properties.getProperty('apiUrl');
const endPoints = require('../../modules/ajio-util/endpoints');

export function resetDeliveryDetails(productCode, isExchangeRquest = false) {
  return {
    type: EDDAction.RESET.DELIVERY_DETAILS,
    productCode,
    isExchangeRquest
  };
}

export function setPincodeModal(status) {
  return {
    type: EDDAction.SET.PINCODE_MODAL,
    status
  };
}

export function setMoveToClosetModal(status) {
  return {
    type: EDDAction.SET.MOVE_TO_CLOSET,
    status
  };
}

function fetchDeliveryDetailsRequest({ pinCode, productCode }) {
  return {
    type: EDDAction.FETCH.DELIVERY_DETAILS.REQUEST,
    pinCode,
    productCode
  };
}

function fetchDeliveryDetailsFailure() {
  return {
    type: EDDAction.FETCH.DELIVERY_DETAILS.FAILURE
  };
}

function fetchDeliveryDetailsSuccess({ pinCode, productDetails, productCode, servicability }) {
  return {
    type: EDDAction.FETCH.DELIVERY_DETAILS.SUCCESS,
    pinCode,
    productDetails,
    productCode,
    servicability
  };
}

/* -------------------- checkDeliveryDetails (v2 / multiseller) -------------------- */

function fetchDeliveryDetailsV2Request({ pinCode, skuId }) {
  return {
    type: EDDAction.FETCH.DELIVERY_DETAILS_V2.REQUEST,
    pinCode,
    skuId
  };
}

function fetchDeliveryDetailsV2Failure({ pinCode, skuId }) {
  return {
    type: EDDAction.FETCH.DELIVERY_DETAILS_V2.FAILURE,
    pinCode,
    skuId
  };
}

function fetchDeliveryDetailsV2Success({
  pinCode,
  skuId,
  requestedSkuId,
  options,
  selectedOption = null
}) {
  return {
    type: EDDAction.FETCH.DELIVERY_DETAILS_V2.SUCCESS,
    pinCode,
    skuId,
    // The sku the REQUEST was keyed by. The response can come back keyed by a
    // different code, so the reducer settles both keys — otherwise the requested
    // one stays `isFetching: true` forever and readers have to guess.
    requestedSkuId,
    options,
    selectedOption
  };
}

function resolveSelectedSlaOption(options = []) {
  if (!Array.isArray(options) || options.length === 0) return null;
  return options.find(option => option?.isSelected) || options[0] || null;
}

/**
 * Format scopedView option price for the product slice.
 * Prefer displayformattedValue (same as SLA cards) — `value` can disagree.
 */
function getScopedViewDisplayPrices(option) {
  const priceData = option?.price?.priceData || {};
  const wasPriceData = option?.price?.wasPriceData || {};
  const fromDisplay = formatted => {
    if (!formatted) return '';
    const numeric = parseInt(String(formatted).replace(/\D/g, ''), 10);
    return Number.isFinite(numeric) ? `₹${Math.round(numeric)}` : '';
  };
  const discountPrice =
    fromDisplay(priceData.displayformattedValue || priceData.formattedValue) ||
    (priceData.value != null && priceData.value !== ''
      ? `₹${Math.round(priceData.value)}`
      : '');
  if (!discountPrice) return null;
  const originalPrice =
    fromDisplay(wasPriceData.displayformattedValue || wasPriceData.formattedValue) ||
    (wasPriceData.value != null && wasPriceData.value !== ''
      ? `₹${Math.round(wasPriceData.value)}`
      : '');
  return { discountPrice, originalPrice };
}

function applyScopedViewPrice({ discountPrice, originalPrice }) {
  return {
    type: 'APPLY_SCOPED_VIEW_PRICE',
    discountPrice,
    originalPrice
  };
}

/**
 * Mirror scopedView option price into the product slice (desktop Description +
 * other discountPrice readers). selectedSlaOption is already set by SUCCESS / SET.
 */
function applyScopedViewOptionPrice(option) {
  return dispatch => {
    if (!option) return;
    const prices = getScopedViewDisplayPrices(option);
    if (prices) {
      dispatch(applyScopedViewPrice(prices));
    }
  };
}

/**
 * Persist selected scopedView option and mirror its price into the product slice.
 */
function applyScopedViewOption(option) {
  return dispatch => {
    if (!option) return;
    dispatch({ type: EDDAction.SET.SELECTED_SLA_OPTION, option });
    dispatch(applyScopedViewOptionPrice(option));
  };
}

/**
 * Drop the active scopedView option.
 *
 * Needed when the UI moves to a context that has no size selected yet (e.g. the
 * desktop wishlist opening its Size/Quantity popup for another product) —
 * otherwise the previous product's option is still the "selected" one.
 */
export function clearSelectedSlaOption() {
  return { type: EDDAction.SET.SELECTED_SLA_OPTION, option: null };
}

/**
 * Map scopedView priceType (BEST_PRICE / BEST_SPEED) and legacy best/fastest
 * to the UI key used for matching view-model selection.
 */
function toUiPriceType(priceType) {
  const key = String(priceType || '')
    .trim()
    .toUpperCase()
    .replace(/-/g, '_');
  if (key === 'BEST_SPEED' || key === 'FASTEST') return 'fastest';
  if (key === 'BEST_PRICE' || key === 'BEST') return 'best';
  return String(priceType || '').toLowerCase();
}

/**
 * Resolve raw scopedView option from a UI card selection (msite `id` or desktop
 * `priceGroupId` + `priceType`).
 */
function findRawSlaOption(options = [], viewOption) {
  if (!viewOption || !Array.isArray(options) || options.length === 0) return null;

  const viewId = viewOption.id || viewOption.priceGroupId;
  const viewPriceType = toUiPriceType(viewOption.priceType);

  const byId = viewId
    ? options.find((option, index) => {
        const optionId = option?.priceGroupId || option?.priceType || `sla-${index}`;
        return String(optionId) === String(viewId);
      })
    : null;

  if (byId) return byId;

  if (viewPriceType) {
    const byPriceType = options.find(
      option => toUiPriceType(option?.priceType) === viewPriceType
    );
    if (byPriceType) return byPriceType;
  }

  return null;
}

/**
 * User picked Best/Fastest (or similar) — update selected scopedView option so
 * offers / EMI / price selectors re-read from that option.
 */
export function selectSlaFromViewOption(viewOption) {
  return (dispatch, getState) => {
    if (!viewOption) return;
    const state = getState();
    const pinCode = state?.edd?.activePincode;
    const skuId = state?.product?.selectedSizeCode;
    const skuEntries = state?.edd?.slaDetails?.[pinCode] || {};
    // Only the selected sku's own options — never another sku's. The card the
    // user clicked belongs to this sku; falling back to whatever else is cached
    // would apply a different size's / product's option.
    const options = (skuId && skuEntries[skuId]?.options) || [];

    const raw = findRawSlaOption(options, viewOption);
    if (raw) {
      dispatch(applyScopedViewOption(raw));
      return;
    }

    // Fallback when id/priceType lookup misses: still update selected option price
    // so getPriceDetails / desktop price UI switch with the card.
    const viewPrices = getScopedViewDisplayPricesFromView(viewOption);
    if (!viewPrices) return;

    const prev = state?.edd?.selectedSlaOption || {};
    const numericDiscount = parseInt(String(viewPrices.discountPrice).replace(/\D/g, ''), 10);
    const numericOriginal = parseInt(String(viewPrices.originalPrice || '').replace(/\D/g, ''), 10);
    dispatch(
      applyScopedViewOption({
        ...prev,
        priceType: viewOption.priceType || prev.priceType,
        priceGroupId: viewOption.id || viewOption.priceGroupId || prev.priceGroupId,
        isSelected: true,
        price: {
          priceData: {
            ...(prev.price?.priceData || {}),
            displayformattedValue: viewPrices.discountPrice,
            ...(Number.isFinite(numericDiscount) ? { value: numericDiscount } : {})
          },
          wasPriceData: {
            ...(prev.price?.wasPriceData || {}),
            displayformattedValue: viewPrices.originalPrice,
            ...(Number.isFinite(numericOriginal) ? { value: numericOriginal } : {})
          }
        }
      })
    );
  };
}

/** Parse msite/desktop view-model price strings into product-slice display values. */
function getScopedViewDisplayPricesFromView(viewOption) {
  const price = viewOption?.price || {};
  const discountPrice = price.price || price.current || '';
  const originalPrice = price.mrp || price.was || '';
  if (!discountPrice) return null;
  return { discountPrice, originalPrice };
}

/**
 * Pull the raw SLA option array for the selected SKU out of a v2 response.
 * `sku` is an array of single-key objects: `[{ [skuId]: RawSlaOption[] }]`.
 */
function extractV2SkuOptions(response, skuId) {
  const skuList = response && Array.isArray(response.sku) ? response.sku : [];
  if (skuList.length === 0) return { options: [], resolvedSkuId: skuId };
  if (skuId) {
    const match = skuList.find(entry => entry && entry[skuId]);
    if (match) return { options: match[skuId] || [], resolvedSkuId: skuId };
  }
  const first = skuList[0] || {};
  const firstKey = Object.keys(first)[0];
  return { options: firstKey ? first[firstKey] || [] : [], resolvedSkuId: firstKey || skuId };
}
/**
 * scopedView productDetails -> the v1 `productDetails` array the legacy EDD
 * reducer/UI expect. Both APIs use the same entry shape (servicability,
 * reasonForNotServiceability, deliveryMethod, edd*), so the entries pass through
 * as-is; only `productCode` is overwritten with the requested sku, since that is
 * the key the reducer stores under and the key the UI reads back. Falls back to a
 * synthetic "not serviceable" entry when the payload carries none — same default
 * v1 uses.
 */
function toLegacyProductDetails(options = [], productCode) {
  const details = (Array.isArray(options) ? options : []).reduce((acc, option) => {
    const entries = option?.serviceabilityDetails?.productDetails;
    return Array.isArray(entries) ? acc.concat(entries.filter(Boolean)) : acc;
  }, []);

  if (details.length === 0) {
    return [
      {
        codEligible: false,
        productCode,
        reasonForNotServiceability: 'NS',
        servicability: false
      }
    ];
  }

  return details.map(detail => ({ ...detail, productCode }));
}

function fetchProductServiceabilityRequest() {
  return {
    type: EDDAction.FETCH.PRODUCT_SERVICEABILITY_DETAILS.REQUEST
  };
}

function fetchProductServiceabilitySuccess(payload) {
  return {
    type: EDDAction.FETCH.PRODUCT_SERVICEABILITY_DETAILS.SUCCESS,
    payload
  };
}
function fetchProductServiceabilityFailure() {
  return {
    type: EDDAction.FETCH.PRODUCT_SERVICEABILITY_DETAILS.FAILURE
  };
}
function dayDifference(delivery_date) {
  const todayDate = new Date();
  const deliveryDate = new Date(delivery_date);
  // calculate time difference
  const time_difference = deliveryDate.getTime() - todayDate.getTime();

  // calculate days difference by dividing total milliseconds in a day
  const days_difference = time_difference / (1000 * 60 * 60 * 24);
  return days_difference;
}

export function fetchDeliveryDetails(
  pincode = getPincodeFromCookie(),
  code,
  quantity = 1,
  isExchange = false
) {
  return (dispatch, getState) => {
    if (!pincode) {
      return;
    }
    const {
      product: { selectedSizeCode = code }
    } = getState();
    // const params = {
    //   productCode: selectedSizeCode,
    //   postalCode: pincode,
    //   quantity: 1,
    //   IsExchange: false,
    // };
    const { location: { href = '' } = {} } = window;
    const {
      pdp: { screenName = '', screenType = '' }
    } = luxeScreen;
    const pcode = code || selectedSizeCode;
    dispatch(fetchDeliveryDetailsRequest({ pinCode: pincode, productCode: pcode }));

    let api = encodeURI(
      `/api/edd/checkDeliveryDetails?productCode=${pcode}&postalCode=${pincode}&quantity=${quantity}&IsExchange=${isExchange}`
    );
    if (isNode()) {
      // if the call is from the node server we will use the api url to make the call
      api = api_url + api;
    }
    return fetcher(api, fetchGetJSONReqOpts({ credentials: 'include' }))
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          productDetails = [
            {
              codEligible: false,
              productCode: pcode,
              reasonForNotServiceability: 'NS',
              servicability: false
            }
          ],
          servicability,
          pinCode,
          status: { statusCode: apiResponseStatusCode = 1 } = {}
        } = response;

        if (apiResponseStatusCode === 1) {
          const errorObj = {
            errorType: 'info',
            message: 'Oops! something went wrong, Please try again'
          };
          dispatch(setErrorObject(errorObj));

          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
          dispatch(fetchDeliveryDetailsFailure());
        } else if (apiResponseStatusCode === 0) {
          if (!isNode()) {
            // gtmEventPush({
            //   event: 'edd_submit',
            //   event_category: 'product details interactions',
            //   event_action: 'estimate delivery date',
            //   event_label: 'submit',
            //   pincode: pinCode,
            //   cod_eligible: productDetails[0].codEligible.toString(),
            //   servicable: productDetails[0].servicability,
            //   EDD:
            //     productDetails[0].eddUpper !== '' ? dayDifference(productDetails[0].eddUpper) : '',
            //   store_type: getHostName(href),
            //   user_status: signInCheck() ? 'logged in' : 'not logged In',
            //   time_of_the_day: '',
            //   login_type: signInCheck() ? 'logged in' : 'not logged In',
            //   page_name: screenName,
            //   page_type: screenType
            // });
          }
          dispatch(
            fetchDeliveryDetailsSuccess({
              pinCode,
              productDetails,
              productCode: selectedSizeCode,
              servicability
            })
          );
        }
        dispatch(hideModal(ModalTypes.EDD_PINCODE));
        dispatch(setPincodeModal(false));
        return Promise.resolve(response);
      })
      .catch(error => {
        dispatch(fetchDeliveryDetailsFailure());
        // what will happen if fail
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode)
          .then((errorObj = {}) => {
            dispatch(setPincodeModal(false));
            // dispatch(showErrorMessage(errorObj));
            dispatch(hideModal(ModalTypes.EDD_PINCODE));
            return Promise.reject(errorObj);
          })
          .catch(error => {
            // handle this error
            // dispatch(showErrorMessage(errorObj));
            return Promise.reject(error);
          });
      });
  };
}

/**
 * Whether the delivery location the user can actually see on screen is set.
 *
 * With rush delivery on, msite shows the AddressBar location, which lives in the
 * USER_ADDR cookie — a stale PC cookie alone must not trigger the call there. Every
 * other flow, msite or desktop, shows the pincode, so PC is the only requirement.
 * The pincode is still needed for the request itself in both cases.
 */
function hasVisibleDeliveryLocation(state, pincode) {
  if (!pincode) return false;
  const isMsite = state?.request?.deviceType === 'mobile';
  if (!(getRushDeliveryFlag(state) && isMsite)) return true;
  try {
    const { pincode: addrPincode = '', formattedAddress = '' } =
      JSON.parse(readCookie('USER_ADDR') || '{}') || {};
    return Boolean(addrPincode || formattedAddress);
  } catch (e) {
    return false;
  }
}

export function fetchDeliveryDetailsV2(
  pincode = getPincodeFromCookie(),
  code,
  quantity = 1,
  isExchange = false,
  optionCode = ''
) {
  return (dispatch, getState) => {
    const state = getState();
    // Gate on the multiseller flag so v2 only fires when the feature is on.
    if (!getMultiSellerSlaFlag(state)) {
      return;
    }
    // No location on screen => nothing to show SLA for, so skip the call.
    if (!hasVisibleDeliveryLocation(state, pincode)) {
      return;
    }
    const {
      product: { selectedSizeCode = code, productDetails: { code: productOptionCode = '' } = {} }
    } = state;
    const pcode = code || selectedSizeCode;
    if (!pcode) {
      return;
    }
    const slaOptionCode = optionCode || productOptionCode;
    dispatch(fetchDeliveryDetailsV2Request({ pinCode: pincode, skuId: pcode }));

    const optionCodeQuery = slaOptionCode ? `&optionCode=${slaOptionCode}` : '';
    let api = encodeURI(
      `/api/edd/scopedView?productCode=${pcode}&postalCode=${pincode}&quantity=${quantity}&IsExchange=${isExchange}${optionCodeQuery}`
    );
    if (isNode()) {
      // if the call is from the node server we will use the api url to make the call
      api = api_url + api;
    }
    return fetcher(api, fetchGetJSONReqOpts({ credentials: 'include' }))
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { status: { statusCode: apiResponseStatusCode = 1 } = {} } = response || {};

        if (apiResponseStatusCode === 1) {
          const errorObj = {
            errorType: 'info',
            message: 'Oops! something went wrong, Please try again'
          };
          dispatch(setErrorObject(errorObj));

          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
          dispatch(fetchDeliveryDetailsV2Failure({ pinCode: pincode, skuId: pcode }));
        } else if (apiResponseStatusCode === 0) {
          // v2 payload is `sku: [{ [skuId]: RawSlaOption[] }]` — store the raw
          // option array; the DeliverySLA mapping layer shapes it for the UI.
          const { options, resolvedSkuId } = extractV2SkuOptions(response, pcode);
          const selectedOption = resolveSelectedSlaOption(options);
          dispatch(
            fetchDeliveryDetailsV2Success({
              pinCode: pincode,
              skuId: resolvedSkuId,
              requestedSkuId: pcode,
              options,
              selectedOption
            })
          );
          if (selectedOption) {
            dispatch(applyScopedViewOptionPrice(selectedOption));
          }
          // Nothing deliverable => the SLA cards have no seller choice to offer,
          // so the UI falls back to the legacy EDD copy. That copy reads the v1
          // slice, which multiseller never populates — seed it from THIS response
          // (scopedView already carries the same productDetails shape) rather
          // than firing the v1 API for data we already have.
          if (!hasServiceableSlaOption(options)) {
            dispatch(
              fetchDeliveryDetailsSuccess({
                pinCode: pincode,
                productDetails: toLegacyProductDetails(options, pcode),
                productCode: pcode,
                servicability: false
              })
            );
          }
        }
        dispatch(hideModal(ModalTypes.EDD_PINCODE));
        dispatch(setPincodeModal(false));
        return Promise.resolve(response);
      })
      .catch(error => {
        dispatch(fetchDeliveryDetailsV2Failure({ pinCode: pincode, skuId: pcode }));
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode)
          .then((errorObj = {}) => {
            dispatch(setPincodeModal(false));
            dispatch(hideModal(ModalTypes.EDD_PINCODE));
            return Promise.reject(errorObj);
          })
          .catch(error => {
            return Promise.reject(error);
          });
      });
  };
}

export function fetchProductServiceability(pincode = getPincodeFromCookie()) {
  return (dispatch, getState) => {
    let userId =
      decodeURIComponent(readCookie('CI')) !== 'null' ? decodeURIComponent(readCookie('CI')) : '';
    const emiEnabled = getEmiDiscountEnableForPDP(getState());
    if (!emiEnabled && !userId) {
      return;
    }
    const {
      product: { productDetails }
    } = getState();

    dispatch(fetchProductServiceabilityRequest());
    const api = encodeURI(`/api/edd/checkProductServiceability`);
    let body = {
      itemDetail: {
        brand: productDetails?.brandName,
        brick: productDetails?.brickCode,
        catalogId: productDetails?.catalog,
        category: productDetails?.brickCategory,
        mrp: productDetails?.wasPriceData?.value,
        name: productDetails?.brickName,
        optionCode: productDetails?.request?.optionCode,
        salesPrice: productDetails?.price?.value,
        subCategory: productDetails?.brickSubCategory
      },
      pincode: pincode,
      userId: userId
    };
    return fetcher(
      api,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { status: { statusCode: apiResponseStatusCode = 0 } = {} } = response;

        const { result: { cod = {}, returnWindow = {}, showEmi = false } = {} } = response;
        if (apiResponseStatusCode != 0 && apiResponseStatusCode != 2) {
          const errorObj = {
            errorType: 'info',
            message: 'Oops! something went wrong, Please try again'
          };
          dispatch(setErrorObject(errorObj));

          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
          dispatch(fetchProductServiceabilityFailure());
        } else if (apiResponseStatusCode === 2) {
          dispatch(fetchProductServiceabilityFailure());
        } else {
          dispatch(
            fetchProductServiceabilitySuccess({
              cod,
              returnWindow,
              showEmi
            })
          );
        }
        dispatch(hideModal(ModalTypes.EDD_PINCODE));
        dispatch(setPincodeModal(false));
        return Promise.resolve(response);
      })
      .catch(error => {
        dispatch(fetchProductServiceabilityFailure());
        // what will happen if fail
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode)
          .then((errorObj = {}) => {
            dispatch(setPincodeModal(false));
            // dispatch(showErrorMessage(errorObj));
            dispatch(hideModal(ModalTypes.EDD_PINCODE));
            return Promise.reject(errorObj);
          })
          .catch(error => {
            // handle this error
            // dispatch(showErrorMessage(errorObj));
            return Promise.reject(error);
          });
      });
  };
}

function fetchCartItemsEDDRequest() {
  return {
    type: EDDAction.FETCH.CART_ITEMS_DELIVERY_DETAILS.REQUEST
  };
}

function fetchCartItemsEDDFailure() {
  return {
    type: EDDAction.FETCH.CART_ITEMS_DELIVERY_DETAILS.FAILURE
  };
}

function checkServiceabilityAPIFailed() {
  return {
    type: 'CHECK_SERVICEABILITY_API_FAILED'
  };
}

function checkServiceabilityAPISuccess() {
  return {
    type: 'CHECK_SERVICEABILITY_API_SUCCESS'
  };
}

function fetchCartItemsEDDSuccess({
  pincode,
  productDetails = [],
  servicability = false,
  codEligible = false
}) {
  return {
    type: EDDAction.FETCH.CART_ITEMS_DELIVERY_DETAILS.SUCCESS,
    pincode,
    productDetails,
    servicability,
    codEligible
  };
}
function getFieldValues(request) {
  if (request) {
    var { U: userName = '', C: cartId = '', A: accessToken } = request.cookies;
  } else {
    var userName = readCookie('A');
    var cartId = readCookie('C');
    var accessToken = readCookie('A');
  }
  return {
    userName,
    cartId,
    accessToken
  };
}

export function fetchCartItemsEDD({ request, id } = {}) {
  return (dispatch, getState) => {
    const { userName, cartId, accessToken } = getFieldValues(request);
    const headerInfo = getFetcherHeader(request);
    const {
      cart: { deliveryInfo: { deliveryAddress: { postalCode: cartPostalCode } = {} } = {} } = {},
      order: { deliveryInfo: { deliveryAddress: { postalCode: orderPostalCode } = {} } = {} } = {},
      addressBook: { postalCode },
      flags: {
        enablePriorityDeliveryPreOrder = 'OFF',
        enableAjioMemberShipProgram = 'OFF',
        ajioMemberShipConfig
      } = {},
      variants: { enablerushdelivery }
    } = getState();

    const channelType = request.device.type === 'phone' ? 'MSITE' : 'WEB';
    const enableAjioMemberShipProgramme =
      (enableAjioMemberShipProgram === 'ON' &&
        ajioMemberShipConfig?.isEnableForCart &&
        channelType === 'MSITE') ||
      false;
    const membershipQuery = `&isMembershipActivated=${enableAjioMemberShipProgramme}`;
    const enablePriorityDelivery = enablePriorityDeliveryPreOrder === 'ON';
    const rushDeliveryEnable =
      enablerushdelivery?.key?.toUpperCase() === 'ON' ? enablerushdelivery?.payload : false;
    const activePincode = cartPostalCode || orderPostalCode || postalCode;
    if (!activePincode) {
      return Promise.resolve();
    }
    console.log('FETCH CART EDD REQUEST', request.device.type);
    dispatch(fetchCartItemsEDDRequest());

    const queryParams = `${userName}/carts/${id ||
      cartId}/checkServiceableCart?pincode=${activePincode}&priorityDeliveryEnable=${enablePriorityDelivery}&rushDeliveryEnable=${rushDeliveryEnable}${membershipQuery}`;
    const url = `${endPoints.get('checkServiceableCart')}/${queryParams}`;

    return fetcher(
      url,
      fetchGetJSONReqOpts({
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${accessToken}`,
          ...headerInfo
        }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          productDetails = [],
          servicability = false,
          codEligible = false,
          status: { statusCode: apiResponseStatusCode = 1 } = {}
        } = response || {};

        if (apiResponseStatusCode === 1) {
          const errorObj = {
            errorType: 'info',
            message: 'Oops! something went wrong, Please try again'
          };
          dispatch(fetchCartItemsEDDFailure());
          dispatch(checkServiceabilityAPIFailed());
          dispatch(setErrorObject(errorObj));
        } else if (apiResponseStatusCode === 0) {
          dispatch(
            fetchCartItemsEDDSuccess({
              pincode: activePincode,
              productDetails,
              servicability,
              codEligible
            })
          );
        }
        return Promise.resolve(response);
      })
      .catch(error => {
        // handle client
        return errorParser(error, getErrorStatusCode(error))
          .then(error => {
            return Promise.reject(error);
          })
          .catch(error => {
            return Promise.reject(error);
          });
      });
  };
}

export function fetchCartItemsEDDFromClient(pincode, isRecursivelyCalling = false) {
  return (dispatch, getState) => {
    dispatch(fetchCartItemsEDDRequest());
    const api = encodeURI(`/api/edd/checkServiceableCart?pincode=${pincode}`);
    return fetcher(api, fetchGetJSONReqOpts({ credentials: 'include' }))
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          productDetails = [],
          servicability = false,
          codEligible = false,
          status: { statusCode: apiResponseStatusCode = 1 } = {}
        } = response || {};

        if (apiResponseStatusCode === 1) {
          const errorObj = {
            errorType: 'info',
            message: 'Oops! something went wrong, Please try again'
          };
          dispatch(fetchCartItemsEDDFailure());
          dispatch(checkServiceabilityAPIFailed());
          dispatch(setErrorObject(errorObj));

          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
          return Promise.resolve(response);
        }
        if (apiResponseStatusCode === 0) {
          dispatch(
            fetchCartItemsEDDSuccess({ pincode, productDetails, servicability, codEligible })
          );
          return Promise.resolve(response);
        }
        return Promise.resolve();
      })
      .catch(error => {
        dispatch(fetchCartItemsEDDFailure());
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode)
          .then((errorObj = {}) => {
            if (statusCode === 401 && !isRecursivelyCalling) {
              return tokenReCreateParser(statusCode, errorObj)
                .then(() => {
                  return Promise.resolve(fetchCartItemsEDDFromClient(pincode, true)(dispatch));
                })
                .catch(err => {
                  return Promise.reject(err);
                });
            }
            return Promise.reject(errorObj);
          })
          .catch(error => {
            return Promise.reject(error);
          });
      });
  };
}

function moveAllNonDeliverableItemToClosetRequest() {
  return {
    type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.REQUEST
  };
}
// function moveAllNonDeliverableItemToClosetFailure() {
//   return {
//     type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.FAILURE
//   }
// }
function moveAllNonDeliverableItemToClosetSuccess() {
  return {
    type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.SUCCESS
  };
}

// function moveAllNonDeliverableItemToClosetRequest() {
//   return {
//     type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.REQUEST
//   }
// }
function moveAllNonDeliverableItemToClosetFailure() {
  return {
    type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.FAILURE
  };
}
// function moveAllNonDeliverableItemToClosetSuccess() {
//   return {
//     type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.SUCCESS
//   }
// }

function removeNonDeliverableItem({ activePincode, productCode }) {
  return {
    type: EDDAction.REMOVE.NON_VELIVERABLE_ITEM,
    activePincode,
    productCode
  };
}

export function moveAllNonDeliverableItemToCloset() {
  return async (dispatch, getState) => {
    dispatch(moveAllNonDeliverableItemToClosetRequest());
    const {
      edd: { eddDetails, activePincode },
      cartItem
    } = getState();
    const items = getServiceOrNonServicabilityItems(cartItem, eddDetails, activePincode, false);
    const promiseArray = [];
    try {
      const entryNumbers = [];
      for (let i = 0; i < items.length; i++) {
        const addToWishList = dispatch(addProductToWishlist(items[i].code, false));
        promiseArray.push(addToWishList);
        entryNumbers.push(items[i].entryNumber);
        removeNonDeliverableItem({ activePincode, productCode: items[i].productCode });
      }
      const bulkDelete = dispatch(deleteBulkItemsFromCart(entryNumbers));
      await Promise.all([...promiseArray, bulkDelete]);
    } catch (err) {
      dispatch(moveAllNonDeliverableItemToClosetFailure());
      window.location = '/cart';
      console.log(err);
    }
    dispatch(moveAllNonDeliverableItemToClosetSuccess());
    window.location = '/cart';
  };
}
